import { render, staticRenderFns } from "./preformatted-modal-basic-form.vue?vue&type=template&id=4368c9d7&scoped=true&"
import script from "./preformatted-modal-basic-form.ts?vue&type=script&lang=ts&"
export * from "./preformatted-modal-basic-form.ts?vue&type=script&lang=ts&"
import style0 from "./preformatted-modal-basic-form.scss?vue&type=style&index=0&id=4368c9d7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4368c9d7",
  null
  
)

export default component.exports